import { render, staticRenderFns } from "./AntonymsRussianLanguagePreview.vue?vue&type=template&id=277d5568&lang=pug&"
import script from "./AntonymsRussianLanguagePreview.vue?vue&type=script&lang=js&"
export * from "./AntonymsRussianLanguagePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports